import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';

export const useTelegramStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const token = localStorage.getItem('telegram_token');
        if (!token) {
          setStatus({ is_logged_in: false, user: null });
          setLoading(false);
          return;
        }
        
        const response = await axios.get(`${config.API_BASE}/telegram/status`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // Handle different response formats
        let statusData = response.data;
        
        // If the response has connected field (old format)
        if (statusData.connected !== undefined) {
          setStatus({
            is_logged_in: statusData.connected,
            user: statusData.user || null
          });
        } 
        // If the response has is_logged_in field (new format)
        else if (statusData.is_logged_in !== undefined) {
          setStatus(statusData);
        }
        // Default fallback
        else {
          setStatus({ is_logged_in: false, user: null });
        }
        
      } catch (error) {
        console.error('Status check failed:', error.message);
        setStatus({ is_logged_in: false, user: null });
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  return { status, loading };
};